var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"environment-monitor"},[_c('DetailStats',{attrs:{"title":_vm.title,"basic-stats":_vm.basicStats,"chart-groups":_vm.chartGroups,"trend-data":_vm.pm25TrendData,"format-value":_vm.formatMetricValue,"get-color":_vm.getMetricColor,"should-hide-unit":_vm.isWindDirection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }